module.exports = __webpack_public_path__ + "img/star.ca9080c5.png";